import { createSelector } from "@reduxjs/toolkit";
import selectAnnotationReducer from "../../annotation/selectors/annotationReducerSelector";
import { RootState } from "../../app";
import { Annotation } from "../../annotator/interfaces/annotation";

type Props = {
  groupBlockId?: string;
};

const selectGroupBlockId = (_: RootState, props: Props) => props.groupBlockId;

const annotationsForGroupBlockSelector = createSelector(
  [selectAnnotationReducer, selectGroupBlockId],
  (annotations, groupBlockId): Array<Annotation> => {
    if (!annotations?.length || !groupBlockId) {
      return [];
    }

    return annotations.filter(
      (annotation) => annotation.groupBlockId === groupBlockId,
    );
  },
);

export default annotationsForGroupBlockSelector;
